import { Label, RadioButton } from '@nokia-csf-uxr/ccfk';
import FieldSet, { FieldSetContent, Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
import { RadioButtonLabelContent } from '@nokia-csf-uxr/ccfk/RadioButton';
import React from 'react';
import { AccountContext } from '../../../contexts/AccountContext';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import EquipmentDetails from './EquipmentDetails';
import Form from 'react-bootstrap/esm/Form';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkUserContext, DualBandLinkReferenceContext } from '../../../contexts/DualBandLinkContext';

/**
 * Standard component to select ETSI or ANSI
 */
export default class Standard extends WLDInputComponent {

    constructor(props: {band: number, bandItem: string}) {
        super(props);
    }

    /**
     * Function is executed when the value of the standard field has been changed
     * @param token user's token to access to the API
     * @param linkUser link information which has given by the user
     * @param newData The new data which has been selected
     */
    onChange(token: string, linkUser: Readonly<any>, newData: {index: number, idEquipNorm: number, equipments: any}) {
        linkUser.define("equipNorms", newData)

        let foundEquip = false;
        newData?.equipments?.forEach((equip:any) => {
            if(equip.idEquip == linkUser[super.getKeyValue("equipType")]?.idEquip) {
                linkUser.define(super.getKeyValue("equipType"), equip);
                foundEquip = true;
                return;
            }
        });
        
        if(!foundEquip) {
            linkUser.define(super.getKeyValue("equipType"), newData?.equipments[0]);
        } else {
            let foundFreq = false;
            linkUser[super.getKeyValue("equipType")]?.frequences?.forEach((freq:any) => {
                if(freq.freq == linkUser[super.getKeyValue("equipFreq")]?.freq) {
                    linkUser.define(super.getKeyValue("equipFreq"), freq);
                    foundFreq = true;
                    return;
                }
            });
            
            if(!foundFreq) {
                linkUser.define(super.getKeyValue("equipFreq"), null);
            } else {
                EquipmentDetails.onChangeFreq(token, linkUser, linkUser[super.getKeyValue("equipFreq")], this.props.bandItem)
            }
        }
    }

    render() {
        return (
        <Form.Group>            
            <Container>
                <Row>
                    <Col>
                        <Form.Label>Standard</Form.Label>
                        <FieldSetContent role="radiogroup" className="standard-FieldSetContent center-radiobnt">
                            <AccountContext.Consumer>
                                {(account) => (
                                    <>
                                    {this.props.band == 1 ?
                                        <SingleBandLinkReferenceContext.Consumer>
                                        {(linkReference) => (
                                            <SingleBandLinkUserContext.Consumer>

                                            {(linkUser) => (
                                                linkReference?.equipNorms?.map((st: {idEquipNorm: number, name: string, equipments: any}, index: any) =>
                                                <>
                                                    <Col>
                                                        <Form.Check
                                                            inline
                                                            label={st.name}
                                                            className="standard-radio-button"
                                                            name="standard"
                                                            type="radio"
                                                            checked={linkUser?.equipNorms?.idEquipNorm == st.idEquipNorm}
                                                            onChange={() => this.onChange(account.token, linkUser, {index: index, ...st}) }
                                                        />
                                                    </Col>
                                                </>
                                                )
                                            )}
                                            </SingleBandLinkUserContext.Consumer>
                                        )}
                                        </SingleBandLinkReferenceContext.Consumer>
                                    :
                                    <>
                                        <DualBandLinkReferenceContext.Consumer>
                                        {(linkReference) => (
                                            <DualBandLinkUserContext.Consumer>

                                            {(linkUser) => (
                                                linkReference?.equipNorms?.map((st: {idEquipNorm: number, name: string, equipments: any}, index: any) =>
                                                <>
                                                    <Col>
                                                        <Form.Check
                                                            inline
                                                            label={st.name}
                                                            className="standard-radio-button"
                                                            name="standard"
                                                            type="radio"
                                                            checked={linkUser?.equipNorms?.idEquipNorm == st.idEquipNorm}
                                                            onChange={() => this.onChange(account.token, linkUser, {index: index, ...st}) }
                                                        />
                                                    </Col>
                                                </>
                                                )
                                            )}
                                            </DualBandLinkUserContext.Consumer>
                                        )}
                                        </DualBandLinkReferenceContext.Consumer>
                                    </>
                                    }
                                    </>
                                )}
                            </AccountContext.Consumer>
                        </FieldSetContent>
                    </Col>
                </Row>
            </Container>

        </Form.Group>
        );
    }

}